import { initializeApp, getApps } from "firebase/app";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const storage = getStorage(app);

export const uploadDrawingFile = (file, adminId, siteId, onProgress) => {
  return new Promise((resolve, reject) => {
    const timestamp  = Date.now();
    const safeName   = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
    const path       = `hiland-surveyors/${adminId}/sites/${siteId}/drawings/${timestamp}_${safeName}`;
    const storageRef = ref(storage, path);
    const task       = uploadBytesResumable(storageRef, file, { contentType: file.type || "application/octet-stream" });

    task.on("state_changed",
      (snap) => { if (onProgress) onProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100)); },
      reject,
      async () => { try { resolve({ firebasePath: path, firebaseURL: await getDownloadURL(task.snapshot.ref) }); } catch(e) { reject(e); } }
    );
  });
};

export { storage };
